import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LoginScreen from '../pages/auth/Login'
import Dashboard from '../pages/dashboard'
import CountryList from '../pages/countries'
import CardList from '../pages/cards'
import DashboardPanel from '../components/DashboardPanel'
import { useAuthContext } from '../hooks/useAuthContext'

export default function RootRoutes() {
	//The user context protects all routes from unauthorized users
	//This is achieved using the <Navigate/> component from react-router-dom
	const { user } = useAuthContext()

	//the routes could have been easier set on the App.js
	//however in a larger app, this would be ideal

	return (
		<BrowserRouter>
			<div className={user ? 'flex bg-gray-100' : ''}>
				{user && <DashboardPanel />}
				<Routes>
					<Route
						path='/'
						element={user ? <Dashboard /> : <Navigate to='/login' />}
					/>
					<Route
						path='/countries'
						element={user ? <CountryList /> : <Navigate to='/login' />}
					/>
					<Route
						path='cards'
						element={user ? <CardList /> : <Navigate to='/login' />}
					/>
					<Route
						path='/login'
						element={user ? <Navigate to='/' /> : <LoginScreen />}
					/>
				</Routes>
			</div>
		</BrowserRouter>
	)
}
